import React, { Component } from 'react';
import { Grid, Header, Icon, Popup, Segment, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { IconHeader } from '../../util/css';
import Info from './Info';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

class Details extends Component {
    constructor(props, context) {
        super(props, context);
        const stored = localStorage.getItem('orgUnitProperty');
        const orgUnitProperty = stored ? JSON.parse(stored) : null;
        this.state = {
            orgUnitProperty: orgUnitProperty,
            loading: !orgUnitProperty,
        };
    }

    componentDidMount() {
        if (!this.state.orgUnitProperty) {
            const id = localStorage.getItem('orgUnitPropertyId');
            if (!id) return;
            this.setState({ loading: true });
            axios.get('/assets/organizational-unit-properties/' + id + '/')
                .then(res => {
                    this.setState({ orgUnitProperty: res.data, loading: false });
                })
                .catch(() => {
                    this.setState({ loading: false });
                    toast('Došlo je do greške pri učitavanju podataka.');
                });
        }
    }

    handleRefresh = () => {
        const { orgUnitProperty } = this.state;
        if (!orgUnitProperty) return;
        this.setState({ loading: true });
        axios.get('/assets/organizational-unit-properties/' + orgUnitProperty.id + '/')
            .then(res => {
                this.setState({ orgUnitProperty: res.data, loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
                toast('Došlo je do greške pri učitavanju podataka.');
            });
    };

    render() {
        const { orgUnitProperty, loading } = this.state;

        if (loading) {
            return (
                <div style={{ paddingTop: '100px', paddingBottom: '100px' }}>
                    <Loader active inline="centered" />
                </div>
            );
        }

        if (!orgUnitProperty) {
            return null;
        }

        return (
            <div>
                <h1> Detalji </h1>
                <Grid columns="equal" centered className="stackable">
                    <Grid.Column>
                        <Segment.Group raised>
                            <Segment>
                                <Header as="h3">
                                    {orgUnitProperty.property.name}
                                    <Header style={IconHeader} floated="right">
                                        <Icon />
                                        <Popup
                                            trigger={<Icon link circular basic floated="right" name="arrow left"
                                                           onClick={() => window.history.go(-1)} />}
                                            content="Nazad"
                                            hideOnScroll
                                            position="top center"
                                        />
                                    </Header>
                                    <Header.Subheader>
                                        Naziv imovine
                                    </Header.Subheader>
                                </Header>
                            </Segment>
                            <Segment>
                                <Info
                                    orgUnitProperty={orgUnitProperty}
                                    onRefresh={this.handleRefresh}
                                />
                            </Segment>
                        </Segment.Group>
                    </Grid.Column>
                </Grid>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default Details;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/Details/Details.js